
<template>
  <div  style="background-color: #f8f8f8;min-height: 100%;padding:10px;">

    <Card  :bordered="false" dis-hover style="margin-bottom:10px;">
      <div style="text-align:left">
        <router-link to="/email">
          <a>返回邮件列表</a>
        </router-link>
      </div>
    </Card>

    <Card  :bordered="false" dis-hover style="margin-bottom:10px;">
      <p slot="title" style="font-weight: bold" v-html="detail.title"></p>

      <div v-html="detail.content">
      </div>

    </Card>

  </div>
</template>
<script>
  export default {
    data(){
      return{
        detail:{}
      }
    },
    created(){
      let id = this.$router.history.current.query.id;
      if(id>0){//加载数据
        let that = this;
        this.$axios.get('/api/email/getById?id='+id).then(function(rs){
          that.detail = rs.data;
        });
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/email/EmailPrev.vue